import axios from 'axios';

const deleteTourItem = async (tourId: string, tourItemId: string) => {
  await axios.post(`/tours/${tourId}/delete_tour_item/${tourItemId}`);
};

export default deleteTourItem;
